import React, { createContext, useContext, useState, useCallback } from 'react';

const translations = {
  de: {
    nav: { home: 'Start', services: 'Leistungen', method: 'ROAD-Framework', blog: 'Insights', contact: 'Gespräch anfragen' },
    hero: {
      badge: 'FÜR UNTERNEHMER, DIE KI WIRKLICH NUTZEN WOLLEN.',
      title: 'AI that moves business.',
      sub: 'Wir bauen KI-Agenten für den Mittelstand. Sie übernehmen Routine in Betrieb, Backoffice und Teamkommunikation.',
      text: 'Als die Eisenbahn Amerika veränderte, haben viele zugeschaut. Andrew Carnegie nicht. Er hat keine Gleise gebaut. Er hat den Stahl geliefert, den jede Meile brauchte, und wurde damit einer der reichsten Unternehmer seiner Zeit.\n\nKI ist die Eisenbahn unserer Zeit. Du musst sie nicht erfinden. Du musst nur deinen Einsatzpunkt finden. Genau dabei helfen wir.',
      cta1: 'Kostenlose Potenzialanalyse (20 Min.)',
      cta2: 'Leistungen ansehen',
    },
    intro: {
      title: 'DU BRAUCHST KEINEN TECH-GIGANTEN. DU BRAUCHST DEN RICHTIGEN HEBEL.',
      paragraphs: [
        'Konzepte gibt es genug. PowerPoints auch. Was fast überall fehlt: jemand, der KI-Automatisierung nicht auf den Bildschirm, sondern in den Alltag bringt – in die Aufgaben, die heute deine Zeit fressen.',
        'EnBet liefert keine Folien. Wir analysieren deinen Betrieb, finden den ersten konkreten Hebel und bauen einen KI-Agenten, der ihn bewegt. Mit dem ROAD×ROME-Framework – weil am Ende nur eines zählt: ein messbares Ergebnis in deinem Betrieb.',
      ],
    },
    why: {
      title: 'KEINE FOLIEN. KEINE THEORIE. KEINE IDEEN, DIE IM ALLTAG NICHT FUNKTIONIEREN.',
      paragraphs: [
        'EnBet kombiniert echtes Betriebsverständnis mit konkretem KI-Know-how. Das macht den Unterschied zwischen KI-Beratung und echter Umsetzung.',
        'Betriebsnahe Diagnose — Ich komme nicht mit einem Fragebogen, sondern mit echtem Verständnis für das, was in einem Betrieb wirklich klemmt. Weil ich selbst Betriebe aufgebaut und skaliert habe.',
        'Klare Priorisierung — Wir sagen auch, was keinen Sinn macht. Ehrliche Einschätzung schützt vor Fehlinvestitionen und bewahrt deine Ressourcen für das, was wirklich wirkt.',
        'Umsetzung zuerst — Roadmaps, KI-Agenten und Schulungen sind kein Selbstzweck. Alles ist darauf ausgerichtet, dass KI-Automatisierung im echten Betrieb ankommt. ROME: Nur messbare Ergebnisse zählen.',
      ],
    },
    audience: {
      title: 'DREI BRANCHEN. EIN PROBLEM: DIE ROUTINE LÄUFT ÜBER DEINEN SCHREIBTISCH.',
      intro: 'Dein Team arbeitet am Kunden. Du hängst in Reporting, Personal und Papierkram. Genau da setzen unsere KI-Agenten an.',
      bullets: [
        { title: 'HANDEL', text: 'Fachhändler und Filialisten, bei denen jede Entscheidung über den Inhaber läuft.' },
        { title: 'GASTRONOMIE', text: 'Betriebe, in denen der Abend nach dem Service am Schreibtisch endet: Dienstplan, Bestellungen, Abrechnung.' },
        { title: 'HANDWERK', text: 'Betriebe, in denen Angebote, Aufmaß und Büro die produktiven Stunden fressen.' },
      ],
      closing: 'Wenn dein Unternehmen auch ohne dich laufen soll, bist du hier richtig. Ein Betrieb, der ohne den Inhaber funktioniert, ist am Ende auch mehr wert.',
    },
    road: {
      label: 'Die EnBet-Methode',
      title: 'ROAD × ROME',
      intro: 'Fast jedes Unternehmen hat irgendwo KI im Einsatz. Kaum eines kann konkrete Ergebnisse vorweisen. Der Grund liegt selten an der Technologie – sondern daran, wie sie eingeführt wird. Das ROAD-Framework aus der angewandten Datenwissenschaft gibt die Antwort. Und alle Wege führen zu ROME: zu echtem, messbarem Ergebnis.',
      steps: [],
    },
    services: {
      label: 'Leistungen',
      title: 'Dein ROAD Trip. Drei Stationen. Ein messbares Ergebnis.',
      subtitle: 'Jedes Modul kannst du einzeln buchen. Zusammen ergeben sie einen Weg: vom ehrlichen Check über die Strategie bis zum KI-Agenten, der bei dir läuft.',
      cta_label: 'Starte deinen ROAD Trip',
      items: [
        {
          title: 'KI Ready Check',
          price_label: 'Festpreis: 850 €',
          price_note: '50 % (425 €) auf Modul 2 anrechenbar',
          subtitle: 'Die ehrliche Diagnose: Wo dich die Routine täglich Zeit und Geld kostet.',
          quote: 'Garbage in, garbage out.',
          quote_sub: 'Ehrliche Daten. Klare Entscheidung. Kein Budget für KI-Experimente verbrennen.',
          kpis: [
            { value: '80 %', label: 'der KI-Einführungen scheitern', source: 'VIER / Trend Report 2025', style: 'warn' },
            { value: '68 %', label: 'haben keine KI-Roadmap', source: 'KI-Studie Mittelstand 2025', style: 'warn' },
            { value: '62 %', label: 'kommen nie über den Pilotstatus', source: 'Kyndryl / Computer Weekly 2025', style: 'warn' },
          ],
          tagline: 'Bevor du investierst, weißt du, was sich lohnt.',
          text: 'Wir messen mit Zahlen, wo dich Routine Zeit und Geld kostet. Ich komme mit einer konkreten Einschätzung. Weil ich selbst Betriebe geführt habe und weiß, wo es klemmt.',
          bullets: [
            { label: 'Echte Daten', text: 'Individuelle Analyse deines Betriebs. Keine automatisierten Textbausteine.' },
            { label: 'Prozess-Diagnose', text: 'Wir finden die Reibungspunkte, Medienbrüche und Engpässe in deinen Abläufen.' },
            { label: 'Quantifizierte Verlustzeiten', text: 'Wir beziffern, wie viel Zeit Routine dich pro Bereich kostet. In Stunden und Euro.' },
            { label: 'Machbarkeits-Check', text: 'Wir prüfen, welche KI-Agenten an deine Systeme andocken können und welche sofort laufen.' },
            { label: 'Investitionssicherheit', text: 'Du weißt vorher, was sich rechnet und was nicht. Das schützt dein Budget.' },
          ],
          duration: 'Individuell ausgearbeitet · Ortsunabhängig & effizient via Remote-Audit',
        },
        {
          title: 'KI-Strategie + erster Agent',
          price_label: 'Investition: 3.500 €',
          price_note: 'Mit Anrechnung aus Modul 1: 3.075 €',
          subtitle: 'Deine Roadmap. Plus der erste KI-Agent, der sofort Routine abnimmt.',
          quote: 'Strategie ist keine PowerPoint. Sondern ein Agent, der morgen arbeitet.',
          quote_sub: 'Strategie ist eine Entscheidung mit Zahlen, Verantwortlichen und Datum.',
          kpis: [
            { value: '+19 %', label: 'Produktivität sind möglich', source: 'McKinsey / Stifterverband 2025', style: 'positive' },
            { value: '65 %', label: 'sind offen für KI im Job', source: 'SD Worx / Quinyx 2024', style: 'positive' },
            { value: '76 %', label: 'erleben arbeitsbedingten Stress', source: 'Quinyx 2024', style: 'positive' },
          ],
          tagline: 'Von der Diagnose zum ersten Agenten, der wirklich läuft.',
          text: 'Du bekommst eine priorisierte Roadmap und den ersten Agenten dazu. Der arbeitet ab Tag eins in deinem Betrieb. Der Check ist im Preis enthalten.',
          bullets: [
            { label: 'KI-Roadmap', text: 'Eine Roadmap mit Prioritäten, Verantwortlichen und Terminen.' },
            { label: 'Erster lauffähiger Agent', text: 'Ein konkreter KI-Agent aus dem Werkzeugkasten, auf deinen Betrieb gesetzt.' },
            { label: 'ROI-Kalkulation', text: 'Wir rechnen vor, was der Agent einspart und was er kostet.' },
            { label: 'Use-Case-Mapping', text: 'Wir priorisieren die Use Cases gemeinsam: nach Hebel und Machbarkeit.' },
            { label: 'Erster Use Case statt Folien', text: 'Der erste Agent arbeitet ab Tag eins in deinem Betrieb.' },
          ],
          duration: '1–2 Wochen Ausarbeitung · Interaktiver Experten-Workshop mit deinen Entscheidern',
        },
        {
          title: 'KI Integration & Skalierung',
          price_label: 'ab 8.000 € Festpreis',
          price_note: 'Umfang nach Bedarf — je nach Anzahl Agenten und Integrationstiefe',
          subtitle: 'Schlüsselfertige Umsetzung. Schritt für Schritt hängt weniger an dir.',
          quote: 'Die beste Strategie scheitert ohne Umsetzung.',
          quote_sub: 'Wir gehen mit dir bis ins Tagesgeschäft. Nicht nur bis zur Folie.',
          kpis: [
            { value: '77 %', label: 'der Tools im Haus kommen nicht an', source: 'SD Worx / Quinyx 2024', style: 'positive' },
            { value: '4–6 Wo.', label: 'bis erster Pilot live', style: 'positive' },
            { value: 'Live', label: 'Kosten-Monitoring inkl.', style: 'positive' },
          ],
          tagline: 'Vom ersten Agenten zum Betrieb, der ohne dich läuft.',
          text: 'Wir bauen weitere Agenten, binden deine Systeme an und schulen dein Team. Schritt für Schritt hängt weniger an dir.',
          bullets: [
            { label: 'Pilot-Setup', text: 'Der erste Pilot läuft nach 4 bis 6 Wochen.' },
            { label: 'System-Integration', text: 'Rollout im laufenden Betrieb. Dein Tagesgeschäft läuft weiter.' },
            { label: 'Kosten- & Qualitätsmonitoring', text: 'Du siehst jederzeit, was API und Hosting kosten.' },
            { label: 'Teamschulungen', text: 'Wir schulen dein Team, bis es die Agenten selbstständig nutzt.' },
            { label: 'Mitwachsende Lösung', text: 'Die Agenten sind anpassbar und wachsen mit deinem Betrieb mit.' },
          ],
          duration: 'Projektlaufzeit ab 3 Monaten · Umfang individuell auf deine Infrastruktur abgestimmt',
        },
      ],
    },
    howWeWork: {
      title: 'WENIGE KUNDEN. VOLLE AUFMERKSAMKEIT. ECHTE ERGEBNISSE.',
      paragraphs: [
        'Wir nehmen bewusst wenige Betriebe gleichzeitig an. Dafür kennen wir jeden davon wirklich. Jedes Projekt hat ein klares Ziel, einen Verantwortlichen und ein Enddatum. Danach läuft dein Betrieb eigenständiger als vorher. Abhängigkeit von uns ist kein Geschäftsmodell.',
      ],
    },
    community: {
      title: 'Lernen endet nicht mit dem Projekt',
      paragraphs: [
        'Rund um EnBet entsteht ein Kreis von Betrieben, die voneinander lernen. Unternehmer mit denselben Problemen tauschen sich aus: Was funktioniert, was nicht, was hat es gekostet. Das bringt oft mehr als jede Einzelberatung.',
      ],
    },
    faq: {
      label: 'Häufige Fragen',
      title: 'Antworten auf die wichtigsten Fragen.',
      subtitle: 'Was Unternehmer am häufigsten wissen wollen, bevor sie mit uns arbeiten.',
      items: [
        {
          question: 'Was kostet eine KI-Beratung bei EnBet Consulting?',
          answer: 'Modul 1 (KI Ready Check) ist Festpreis 850 €. Wenn du danach Modul 2 buchst, rechnen wir 50 % (425 €) an. Modul 2 (KI-Strategie + erster Agent) kostet 3.500 € — mit Anrechnung 3.075 €. Modul 3 (KI Integration & Skalierung) ab 8.000 € Festpreis, je nach Umfang. Der erste 20-Minuten-Check mit Sebastian Funke ist immer kostenlos.',
        },
        {
          question: 'Was bedeutet EnBet?',
          answer: 'EnBet steht für Enable Better Business – Betriebe besser, stärker und eigenständiger machen. Kein Buzzword, sondern unser Anspruch: Am Ende zählt, ob im Betrieb ein messbares Ergebnis entsteht. AI that moves business.',
        },
        {
          question: 'Für wen ist EnBet gemacht?',
          answer: 'Für drei Branchen im Mittelstand: Handel, Gastronomie und Handwerk. Verbindendes Merkmal: Dein Team arbeitet am Kunden, du hängst in Reporting, Personal und Papierkram. Genau da setzen unsere KI-Agenten an.',
        },
        {
          question: 'Muss ich KI verstehen, um mit euch zu arbeiten?',
          answer: 'Nein. Du musst keine KI bauen oder verstehen – du musst nur deinen bestehenden Betrieb mit ihr besser machen. Genau das übernehmen wir: von der Diagnose bis zum fertigen Agenten, der im Alltag läuft.',
        },
        {
          question: 'Wie unterscheidet sich EnBet von klassischer KI-Beratung?',
          answer: 'Die meisten Anbieter müssen deinen Betrieb erst verstehen lernen. Ich komme mit der Diagnose – weil ich selbst Betriebe geführt und skaliert habe. Und wir liefern keine Folien, sondern Agenten, die dir gehören und im Betrieb arbeiten.',
        },
        {
          question: 'Was ist das ROAD × ROME-Framework?',
          answer: 'ROAD (Requirements, Operationalize Data, Analytic Method, Deployment) ist unser strukturierter Weg zur KI-Einführung aus der angewandten Datenwissenschaft. ROME (Result Only Matters Environment) ist das Ziel: Wie alle Straßen nach Rom führen, führt jeder Schritt zu einem echten, messbaren Ergebnis im Betrieb.',
        },
        {
          question: 'Wo ist EnBet Consulting ansässig?',
          answer: 'EnBet Consulting hat seinen Sitz in Schauenburg und arbeitet überregional – Erstgespräche und Analysen laufen effizient remote, Umsetzung auf Wunsch auch vor Ort.',
        },
      ],
    },
    cta: {
      title: 'DEIN KOSTENFREIER POTENZIAL-CHECK.',
      text: '20 Minuten, kostenlos, ohne Pitch. Wir klären, wo KI-Implementierung in deinem Betrieb den größten Hebel hat und ob eine Zusammenarbeit Sinn ergibt.',
      button: 'Jetzt Termin buchen',
      name: 'Name',
      email: 'E-Mail',
      company: 'Unternehmen (optional)',
      message: 'Nachricht',
      send: 'Nachricht senden',
      success: 'Nachricht erfolgreich gesendet!',
      error: 'Fehler beim Senden. Bitte versuchen Sie es erneut.',
    },
    cookie: {
      headline: 'Volle Kontrolle für deinen Betrieb.',
      text: 'Mit deinem Einverständnis nutzen wir Google Analytics und PostHog, um die Seite zu verbessern. IP-Adressen werden anonymisiert. Du kannst jederzeit widerrufen — Details in der',
      accept: 'Einverstanden & Optimieren',
      decline: 'Nur das Nötigste',
      privacy: 'Datenschutzerklärung',
    },
    blog: { label: 'Insights', title: 'Aktuelle Beiträge', readMore: 'Zum Beitrag' },
    footer: { rights: 'Alle Rechte vorbehalten.', privacy: 'Datenschutz', imprint: 'Impressum', tagline: 'EnBet – Enable Better Business · AI that moves business.' },
    newsletter: {
      title: 'Alle 6 Wochen ein KI-Use-Case aus deinem Alltag.',
      intro: 'Pro Ausgabe: ein konkretes Beispiel + die Technologie dahinter + ehrliche Aufwands-Einschätzung + Quellen. Kein Bullshit, keine Buzzwords.',
      cta: 'Anmelden',
    },
  },
  en: {
    nav: { home: 'Home', services: 'Services', method: 'ROAD Framework', blog: 'Insights', contact: 'Request consultation' },
    hero: {
      badge: 'FOR ENTREPRENEURS WHO ACTUALLY WANT TO USE AI.',
      title: 'AI that moves business.',
      sub: 'We build AI agents for the German Mittelstand. They take over routine in operations, back-office and team communication.',
      text: 'When the railroad changed America, many watched. Andrew Carnegie did not. He did not build tracks. He delivered the steel every mile needed, and became one of the richest entrepreneurs of his time.\n\nAI is the railroad of our time. You do not have to invent it. You just have to find your point of entry. That is exactly where we help.',
      cta1: 'Free potential analysis (20 min)',
      cta2: 'View services',
    },
    intro: {
      title: 'AI needs more than good tools.',
      paragraphs: [
        "There are plenty of concepts. Plenty of strategy decks. What's missing is someone who makes sure AI lands not on a screen but in daily operations — in the tasks that eat your time today.",
        "EnBet doesn't deliver slides. We build AI agents that work in real operations and develop roadmaps that run with your team — not against it.",
        'With the ROAD×ROME framework we analyse where your business can be relieved today and where measurable value emerges tomorrow. Because in the end all roads lead to one goal: a real result in operations.',
      ],
    },
    why: {
      title: 'No off-the-shelf AI consulting.',
      paragraphs: [
        "EnBet combines deep understanding of operational reality with concrete AI know-how. That's what sets us apart from classic consulting.",
        "Operator's perspective — No generic AI knowledge that fits everyone. Real understanding of how businesses run — because I have led and scaled businesses myself. I don't come with a questionnaire, but with a diagnosis.",
        "Clear prioritisation — We also tell you what doesn't make sense. Honest assessment protects you from bad investments — and preserves your resources for what actually works.",
        'Implementation first — Roadmaps, agents and training are not ends in themselves. Everything is built so AI lands in real operations — guided by the ROME principle: only measurable results count.',
      ],
    },
    audience: {
      title: 'THREE INDUSTRIES. ONE PROBLEM: ROUTINE RUNS OVER YOUR DESK.',
      intro: 'Your team works with customers. You are stuck in reporting, staffing and paperwork. That is exactly where our AI agents come in.',
      bullets: [
        { title: 'RETAIL', text: 'Independent retailers and chains where every decision flows through the owner.' },
        { title: 'GASTRONOMY', text: 'Businesses where the evening after service ends at the desk: rotas, orders, accounting.' },
        { title: 'TRADES', text: 'Businesses where offers, measurements and paperwork eat the productive hours.' },
      ],
      closing: 'If you want your business to run without you, you are in the right place. A business that works without the owner is also worth more in the end.',
    },
    road: {
      label: 'The EnBet Method',
      title: 'ROAD × ROME',
      intro: "Almost every company is using AI somewhere. Hardly any can show concrete results. The reason is rarely the technology — it's how it gets introduced. The ROAD framework from applied data science answers that. And all roads lead to ROME: to real, measurable results.",
      steps: [],
    },
    services: {
      label: 'Services',
      title: 'Your ROAD Trip. Three stations. One measurable result.',
      subtitle: 'Each module can be booked individually. Together they form a path: from the honest check, through strategy, to the AI agent that runs in your business.',
      cta_label: 'Start your ROAD trip',
      items: [
        {
          title: 'AI Ready Check',
          price_label: 'Fixed price: € 850',
          price_note: '50 % (€ 425) credited towards Module 2',
          subtitle: 'The honest diagnosis: where routine costs you time and money every day.',
          quote: 'Garbage in, garbage out.',
          quote_sub: 'Honest data. Clear decisions. No budget burned on AI experiments.',
          kpis: [
            { value: '80 %', label: 'of AI rollouts fail', source: 'VIER / Trend Report 2025', style: 'warn' },
            { value: '68 %', label: 'have no AI roadmap', source: 'KI-Studie Mittelstand 2025', style: 'warn' },
            { value: '62 %', label: 'never get past pilot stage', source: 'Kyndryl / Computer Weekly 2025', style: 'warn' },
          ],
          tagline: 'Before you invest, you know what is worth it.',
          text: 'We measure with numbers where routine costs you time and money. I come with a concrete assessment, because I have run businesses myself and know where it hurts.',
          bullets: [
            { label: 'Real data', text: 'Individual analysis of your business. No automated boilerplate.' },
            { label: 'Process diagnostic', text: 'We find the friction points, media breaks and bottlenecks in your operations.' },
            { label: 'Quantified time loss', text: 'We put hard numbers on how much time routine costs you. In hours and euros.' },
            { label: 'Feasibility check', text: 'We test which AI agents can dock onto your systems and which can run immediately.' },
            { label: 'Investment safety', text: 'You know upfront what pays off and what does not. That protects your budget.' },
          ],
          duration: 'Individually prepared · location-independent via remote audit',
        },
        {
          title: 'AI strategy + first agent',
          price_label: 'Investment: € 3,500',
          price_note: 'With credit from Module 1: € 3,075',
          subtitle: 'Your roadmap. Plus the first AI agent that takes over routine immediately.',
          quote: 'Strategy is not a PowerPoint. It is an agent that works tomorrow.',
          quote_sub: 'Strategy is a decision with numbers, owners and a date.',
          kpis: [
            { value: '+19 %', label: 'productivity gain possible', source: 'McKinsey / Stifterverband 2025', style: 'positive' },
            { value: '65 %', label: 'are open to AI in their job', source: 'SD Worx / Quinyx 2024', style: 'positive' },
            { value: '76 %', label: 'experience work-related stress', source: 'Quinyx 2024', style: 'positive' },
          ],
          tagline: 'From diagnosis to the first agent that actually runs.',
          text: 'You get a prioritised roadmap and the first agent on top. It works from day one in your business. The Check is included in the price.',
          bullets: [
            { label: 'AI roadmap', text: 'A roadmap with priorities, owners and dates.' },
            { label: 'First running agent', text: 'A concrete AI agent from the toolkit, set up for your business.' },
            { label: 'ROI calculation', text: 'We model what the agent saves and what it costs.' },
            { label: 'Use-case mapping', text: 'We prioritise use cases jointly: by leverage and feasibility.' },
            { label: 'First use case, not slides', text: 'The first agent works from day one in your business.' },
          ],
          duration: '1–2 weeks preparation · Interactive expert workshop with your decision-makers',
        },
        {
          title: 'AI Integration & Scaling',
          price_label: 'from € 8,000 fixed price',
          price_note: 'Scope by need — depending on number of agents and integration depth',
          subtitle: 'Turnkey implementation. Step by step, less hangs on you.',
          quote: 'The best strategy fails without execution.',
          quote_sub: 'We stay with you into daily operations. Not just to the slide deck.',
          kpis: [
            { value: '77 %', label: 'of in-house tools never land in operations', source: 'SD Worx / Quinyx 2024', style: 'positive' },
            { value: '4–6 wks', label: 'until first pilot live', style: 'positive' },
            { value: 'Live', label: 'cost monitoring included', style: 'positive' },
          ],
          tagline: 'From the first agent to a business that runs without you.',
          text: 'We build more agents, connect your systems and train your team. Step by step, less hangs on you.',
          bullets: [
            { label: 'Pilot setup', text: 'The first pilot runs within 4 to 6 weeks.' },
            { label: 'System integration', text: 'Rollout during live operations. Your daily business keeps running.' },
            { label: 'Cost & quality monitoring', text: 'You see at any time what API and hosting cost.' },
            { label: 'Team training', text: 'We train your team until they use the agents on their own.' },
            { label: 'Solution that grows with you', text: 'The agents are customisable and grow with your business.' },
          ],
          duration: 'Project duration from 3 months · scope tailored to your infrastructure',
        },
      ],
    },
    howWeWork: {
      title: 'How we work together.',
      paragraphs: [
        'We deliberately take on few businesses at the same time. That way we know each one for real. Every project has a clear goal, a responsible owner and an end date. After that, your business runs more independently than before. Dependence on us is not our business model.',
      ],
    },
    community: {
      title: 'Learning does not end with the project',
      paragraphs: [
        'A circle of businesses learning from each other is forming around EnBet. Owners with the same problems exchange notes: what works, what does not, what it cost. That often delivers more than any single consultancy.',
      ],
    },
    faq: {
      label: 'Frequently asked',
      title: 'Answers to the questions that matter.',
      subtitle: 'What owners most often want to know before working with us.',
      items: [
        {
          question: 'What does AI consulting at EnBet Consulting cost?',
          answer: 'Module 1 (AI Ready Check) is a fixed price of € 850. If you book Module 2 afterwards, we credit 50 % (€ 425). Module 2 (AI strategy + first agent) costs € 3,500 — with the credit, € 3,075. Module 3 (AI Integration & Scaling) from € 8,000 fixed price, depending on scope. The first 20-minute check with Sebastian Funke is always free.',
        },
        {
          question: 'What does EnBet mean?',
          answer: 'EnBet stands for Enable Better Business — making businesses better, stronger and more independent. Not a buzzword but our claim: in the end what counts is whether a measurable result emerges in operations. AI that moves business.',
        },
        {
          question: 'Who is EnBet for?',
          answer: 'For three industries in the German Mittelstand: retail, gastronomy and trades. Connecting feature: Your team works with customers, you are stuck in reporting, staffing and paperwork. That is exactly where our AI agents come in.',
        },
        {
          question: 'Do I need to understand AI to work with you?',
          answer: "No. You don't need to build or understand AI — you just need to make your existing business better with it. That's exactly what we take over: from diagnosis to the finished agent running in daily operations.",
        },
        {
          question: 'How is EnBet different from classic AI consulting?',
          answer: "Most providers first have to learn to understand your business. I come with the diagnosis — because I have run and scaled businesses myself. And we don't deliver slides but agents that belong to you and work in your business.",
        },
        {
          question: 'What is the ROAD × ROME framework?',
          answer: 'ROAD (Requirements, Operationalize Data, Analytic Method, Deployment) is our structured path to AI adoption from applied data science. ROME (Result Only Matters Environment) is the goal: as all roads lead to Rome, every step leads to a real, measurable result in operations.',
        },
        {
          question: 'Where is EnBet Consulting based?',
          answer: 'EnBet Consulting is based in Schauenburg and works nationwide — first calls and analyses run efficiently remotely, implementation on-site on request.',
        },
      ],
    },
    cta: {
      title: 'YOUR FREE POTENTIAL CHECK.',
      text: '20 minutes, free, no pitch. We clarify where AI implementation has the biggest leverage in your business and whether working together makes sense.',
      button: 'Schedule a consultation',
      name: 'Name',
      email: 'Email',
      company: 'Company (optional)',
      message: 'Message',
      send: 'Send message',
      success: 'Message sent successfully!',
      error: 'Error sending message. Please try again.',
    },
    cookie: {
      headline: 'Full control for your business.',
      text: 'With your consent we use Google Analytics and PostHog to improve this site. IP addresses are anonymized. You can revoke anytime — details in our',
      accept: 'Agree & Optimize',
      decline: 'Essentials Only',
      privacy: 'Privacy Policy',
    },
    blog: { label: 'Insights', title: 'Latest Posts', readMore: 'Read article' },
    footer: { rights: 'All rights reserved.', privacy: 'Privacy', imprint: 'Imprint', tagline: 'EnBet – Enable Better Business · AI that moves business.' },
    newsletter: {
      title: 'A real-world AI use-case every 6 weeks.',
      intro: 'Per issue: one concrete example + the technology behind it + an honest effort estimate + sources. No bullshit, no buzzwords.',
      cta: 'Sign up',
    },
  },
};

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState('de');
  const t = useCallback((key) => {
    const keys = key.split('.');
    let result = translations[lang];
    for (const k of keys) { result = result?.[k]; }
    return result || key;
  }, [lang]);
  const toggleLang = useCallback(() => setLang(p => p === 'de' ? 'en' : 'de'), []);
  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
}
